module.exports = __webpack_public_path__ + "img/wa1.7348103c.jpg";